import React from 'react'
import Breadcrumb from '../common/Breadcrumb'
import TestimonialSlider from '../component/testimonial'

const Testimonials = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Testimonials"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Testimonials" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section>
      <div class="container">
        <div class="row align-items-center">
          <TestimonialSlider />         
        </div>
      </div>
    </section>
    </>
  )
}

export default Testimonials
